<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Library Cache'"
    [icon]="'library_books'"
>
    <div class="content">
        <div class="header">
            <mat-form-field class="search-field">
                <mat-label>Search by prefix</mat-label>
                <input #searchField
                       matInput
                       [(ngModel)]="searchText"
                       (keyup.enter)="loadCacheKeys()" />
            </mat-form-field>
            <button mat-stroked-button (click)="loadCacheKeys()">
                <mat-icon>search</mat-icon>
                Search
            </button>
            <mat-checkbox [(ngModel)]="showKey">View Keys</mat-checkbox>

        </div>

        @for (cacheKey of cacheKeys; track cacheKey) {
            <mat-card class="cache-entry">
                <mat-card-header>
                    <mat-card-title><code>{{ cacheKey.resource }}</code></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    @if (showKey) {
                        <div>Key: <code>{{ cacheKey.key }}</code></div>
                    }
                    <div>
                        <ul>
                            @for (option of cacheKey.options; track option) {
                                <li><code>{{ option.name }}</code>: <code>{{ option.value }}</code></li>
                            }
                        </ul>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button (click)="getCacheEntry(cacheKey)">INFO</button>
                    <button mat-button [disabled]="deletingKeys.has(cacheKey.key)" (click)="deleteCacheEntry(cacheKey.key)">DELETE</button>
                </mat-card-actions>
            </mat-card>
        } @empty {
            No cache entries found.
        }
    </div>
</admin-page-simple-content>
